<template>
  <!-- 先复用现有订单发货页面布局，保证左侧菜单可正常跳转 -->
  <OrderManagement />
</template>

<script>
import OrderManagement from './OrderManagement.vue'

export default {
  name: 'OrdersSituation',
  components: { OrderManagement }
}
</script>

